var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      







































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-header\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-10\"\u003E\u003Cdiv class=\"p\"\u003EHier finden Sie aktuelle Entscheidungen, die von Ihnen getroffen werden müssen.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"list-box\"\u003E\u003Cdiv class=\"list-box__row\" ng-repeat=\"process in $ctrl.user_decision_processes\" toggable-content=\"toggableStatus\" ng-class=\"{&quot;toggable-content-open&quot;: !toggableStatus}\" ng-if=\"!$ctrl.loading.processes\"\u003E\u003Ctoggable-content-toggler ng-click=\"toggleContentShowable\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"togglerClicked()\" data-cy=\"vn.userDecisions.common.{{process.entity_id}}.toggleUserDecision\"\u003E\u003Cdiv class=\"toggable-state-feedback\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"user-name\"\u003E{{process.created_at*1000 | date:'yyyy-MM-dd HH:mm'}} | {{$ctrl.USER_DECISION_PROCESS_TYPES_BY_ID[process.type_id]['display']}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"toggableStatus\"\u003E\u003Cdiv class=\"main transparent\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv\u003E\u003Cp ng-repeat=\"paragraph in $ctrl.USER_DECISION_PROCESS_TYPES_BY_ID[process.type_id]['description']\"\u003E{{paragraph}}\u003C\u002Fp\u003E\u003Cdiv class=\"row\" ng-if=\"process.entity\"\u003E\u003Cdiv ng-if=\"process['type_id'] === $ctrl.USER_DECISION_PROCESS_TYPES_BY_NAME['mpp_buying_decision']['id']\" ng-init=\"basket = process['entity']\"\u003E\u003Cp\u003EPC Leasing - {{basket['beginDate'] | date }} - {{basket['endDate'] | date }} - Neuwert: {{basket['brutto_sum'] | currency: 'EUR'}} - Kaufangebot: {{basket['netto_sum'] * $ctrl.endprice_percentage * 1.19 | currency:'EUR' }}\u003C\u002Fp\u003E\u003Ctable\u003E\u003Ctr\u003E\u003Cth\u003EGerätebezeichnung und Zustand\u003C\u002Fth\u003E\u003Cth\u003EStück\u003C\u002Fth\u003E\u003Cth\u003ENeuwert\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctr ng-repeat=\"article in basket['articles']\"\u003E\u003Ctd\u003E{{article['Artikelname']}}, gebraucht\u003C\u002Ftd\u003E\u003Ctd\u003E{{article['quantity']}}\u003C\u002Ftd\u003E\u003Ctd\u003E{{article['price'] | currency}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftable\u003E\u003Cp\u003EBitte entscheiden Sie, ob Sie die Endgeräte übernehmen möchten oder ob Sie zum Ende der Laufzeit die Artikel zurückgeben möchten. Je nach Auswahl gelangen Sie in den jeweiligen Abwicklungsprozess, welcher zu jeder Zeit abgebrochen werden kann.\u003C\u002Fp\u003E\u003Cp\u003EBitte beachten Sie, dass ein Kauf nur für den gesamten Umfang der Nutzungsüberlassung gelten und keine Auswahl einzelner Artikel getroffen werden kann.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EBitte berücksichtigen Sie die folgenden Hinweise, wenn Sie die Geräte zum Ablauf zurückggeben möchten.\u003C\u002Fstrong\u003E\u003Cli\u003EBei Rückgabe sind die Geräte gereinigt an ValueNet zurückzugegeben.\u003C\u002Fli\u003E\u003Cli\u003EDie Geräte haben bei der Rückgabe in einem der vertragsgemäßen Abnutzung entsprechenden Zustand zu sein, d.h. die Geräte müssen funktionsfähig und optisch einwandfrei sein. Die Festplatte muss gereinigt, Passwörter oder Kontoverbindungen müssen deaktiviert sein. Die Geräte müssen vollständig, inkl. aller zur Installation notwendigen Datenträger (Booting und Recovery-CD, DVD oder Disketten) sowie Kabel und Zubehör zurückgegeben werden.\u003C\u002Fli\u003E\u003Cli\u003EEntsprechen die Geräte bei Rückgabe nicht dem beschriebenen Zustand kann ValueNet den Ausgleich eines hierdurch bedingten Minderwertes verlangen. Solltesich nicht auf die Höhe des auszugleichenden Minderwertes geeinigt werden können, so wird ValueNet dessen Feststellung über einen vereidigten Sachverständigen\nveranlassen. Die Kosten trägt derjenige dessen Ansicht nicht bestätigt wird. Ansonsten trägt jeder die Hälfte der Kosten.\u003C\u002Fli\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"option in $ctrl.USER_DECISION_PROCESS_TYPES_BY_ID[process['type_id']]['available_options']\"\u003E\u003Cp style=\"white-space: pre-line\"\u003E{{ option.display.description}}\u003C\u002Fp\u003E\u003Cbutton class=\"button button-primary\" ng-if=\"option['display_widget_type_id'] === $ctrl.USER_DECISION_PROCESS_OPTIONS_DISPLAY_WIDGET_TYPES_BY_NAME['button']['id']\" ng-click=\"$ctrl.handleOption(process, option)\" data-cy=\"{{$ctrl.generateCyData(process, option)}}\"\u003E{{ option.display.text }}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"list-box\"\u003E\u003Cdiv class=\"list-box__row\" ng-repeat=\"makuDecisionProcess in $ctrl.makuDecisionProcess\" toggable-content=\"toggableStatus\" ng-class=\"{&quot;toggable-content-open&quot;: !toggableStatus}\" ng-if=\"!$ctrl.loading.processes\"\u003E\u003Ctoggable-content-toggler ng-click=\"toggleContentShowable\"\u003E\u003Cdiv class=\"list-box__item\" style=\"background-color: lightyellow\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"togglerClicked()\" data-cy=\"vn.userDecisions.common.makuDecisionProcess.toggleUserDecision\"\u003E\u003Cdiv class=\"toggable-state-feedback\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"user-name\"\u003E{{makuDecisionProcess.created_at | date:'yyyy-MM-dd HH:mm'}} | Mitarbeiter KurzurlaubCard\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-if=\"toggableStatus\"\u003E\u003Cdiv class=\"main transparent\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv\u003E\u003Cp\u003EAktuell ist Ihre Erholungsbeihilfe als jährliche Auszahlung über Ihr Entgelt konfiguriert.\u003C\u002Fp\u003E\u003Cp\u003ESie können nun entscheiden, ob Sie die Auszahlung des Gesamtbetrages über Ihr Entgelt beibehalten wollen oder die Mitarbeiter KurzurlaubCard nutzen möchten.\u003C\u002Fp\u003E\u003Cp class=\"strong\"\u003EEntdecken Sie die Schönheit Europas mit unserer Urlaubs-Flatrate\u003C\u002Fp\u003E\u003Cp\u003EMit der Mitarbeiter KurzurlaubCard erhalten Sie unbegrenzten Zugang zu unserer Hotelwelt.\u003C\u002Fp\u003E\u003Cp\u003ESie entscheiden, wann und wie lange Sie verreisen und wie oft Sie im Jahr Ihre Koffer packen - und das für 2 bis 14 Nächte am Stück.\u003C\u002Fp\u003E\u003Cp class=\"strong\"\u003EAlle Möglichkeiten der KurzurlaubCard finden Sie&nbsp;\u003Ca href=\"https:\u002F\u002Fkurzurlaubcard.de\u002Fsuche\"\u003Ehier.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp class=\"strong\"\u003EIhre Vorteile:\u003C\u002Fp\u003E\u003Cul class=\"list-box__item-content-options\"\u003E\u003Cli\u003EUnbegrenzte Kurzurlaube innerhalb von 12 Monaten von 2-14 Tagen\u003C\u002Fli\u003E\u003Cli\u003EFür 2 Personen im Doppelzimmer (plus bis zu 2 Kinder)\u003C\u002Fli\u003E\u003Cli\u003EIn 1.500 Ferienhotels in 20 Europäischen Ländern (über 450 Hotels in Deutschland)\u003C\u002Fli\u003E\u003Cli\u003EKostenlose Übernachtungen\u003C\u002Fli\u003E\u003Cli\u003EZahlung des daydreams-Genusspaket (Frühstück & Abendessen) direkt im Hotel\u003C\u002Fli\u003E\u003Cli\u003EMindestens 30 % Ersparnis gegenüber einer regulären Buchung im Hotel\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp class=\"strong\" style=\"text-decoration: underline\"\u003EWie funktioniert es?\u003C\u002Fp\u003E\u003Cp\u003ESie haben innerhalb Ihrer jährlichen Erholungsbeihilfe die Möglichkeit, sich für die KurzurlaubCard zu entscheiden.\nIn diesem Fall erhalten Sie zum Zeitpunkt der Auszahlung den Code zur Freischaltung der KurzurlaubCard.\nDafür investieren Sie 96,00 € aus Ihrem jährlichen Betrag der Erholungsbeihilfe.\nDie Differenz zum maximalen jährlichen Betrag (156,00 €) erhalten Sie zum Auszahlungszeitpunkt mit Ihrem Entgelt ausgezahlt.\u003C\u002Fp\u003E\u003C!--p--\u003E\u003C!--  |--\u003E\u003C!--  span.strong Sie haben&nbsp;--\u003E\u003C!--  span.strong.red 2 Wochen Zeit (gibt es eine automatische Rückrechnung zum Auszahlungszeitpunkt? Die Erinnerungsmail führt ja auch auf diese Seite und dann sind es nur noch 7 Tage)&nbsp;--\u003E\u003C!--  span.strong--\u003E\u003C!--    | , sich für eine--\u003E\u003C!--    | Alternative Ihrer Erholungsbeihilfe zu entscheiden. Sollten Sie keine Entscheidung treffen, wird--\u003E\u003C!--    | automatisch der Auszahlungsmodus des Gesamtbetrages über das Entgelt ausgelöst. Ihre--\u003E\u003C!--    | Entscheidung kann für den Geltungszeitraum der Erholungsbeihilfe dieses Jahres nicht rückgängig--\u003E\u003C!--    | gemacht werden.--\u003E\u003Cp class=\"strong\"\u003EBitte treffen Sie hier Ihre Entscheidung.\u003C\u002Fp\u003E\u003Cp\u003ESie haben 4 Wochen Zeit, sich für eine Alternative Ihrer Erholungsbeihilfe zu entscheiden.\nSollten Sie keine Entscheidung treffen, wird automatisch der Auszahlungsmodus des Gesamtbetrages über das Entgelt ausgelöst.\nIhre Entscheidung kann für den Geltungszeitraum der Erholungsbeihilfe dieses Jahres nicht rückgängig gemacht werden.\u003C\u002Fp\u003E\u003Cdiv class=\"list-box__item-maku-decisions\"\u003E\u003Cbutton class=\"button button-primary list-box__item-maku-decisions--yes\" ng-click=\"$ctrl.makuDecision(makuDecisionProcess, true)\"\u003EJa, ich möchte die KurzurlaubCard bestellen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button list-box__item-maku-decisions--no\" ng-click=\"$ctrl.makuDecision(makuDecisionProcess, false)\"\u003ENein, ich wünsche die Auszahlung meiner Erholungsbeihilfe über die Entgeltabrechnung\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;